<template>
  <div class="ay-login">
    <div class="ay-login__bg"></div>
    <div class="ay-login__mask"></div>

    <div class="ay-login__content" v-if="infoType == 0">
      <div class="ay-login__brand">
        <div class="ay-login__brandText">
          <div class="ay-login__brandTitle">聚盈国际</div>
          <div class="ay-login__brandSub">JYGJ GAME</div>
        </div>
      </div>

      <div class="ay-login__panel">
        <div class="ay-login__form">
          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 12a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0 2c-4.42 0-8 2-8 4.5V21h16v-2.5C20 16 16.42 14 12 14Z" />
              </svg>
            </div>
            <input v-model="loginInfo.name" maxlength="32" placeholder="用户名" autocomplete="off" />
          </div>

          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 0 1 4 0v2h-4Zm7 12H7v-8h10Z" />
              </svg>
            </div>
            <input v-model="loginInfo.password" maxlength="32" placeholder="密码" :type="psw1 ? 'password' : 'text'" autocomplete="off" />
            <div class="ay-field__action" @click="changPsw('psw1')">
              <svg v-if="psw1" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M12 6c5 0 9 6 9 6s-4 6-9 6s-9-6-9-6s4-6 9-6Zm0 10a4 4 0 1 0-4-4a4 4 0 0 0 4 4Z"
                />
              </svg>
              <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M2.3 3.7L3.7 2.3l18 18-1.4 1.4-2.1-2.1A10.8 10.8 0 0 1 12 18C7 18 3 12 3 12a21.3 21.3 0 0 1 4-4.5ZM12 8a4 4 0 0 1 4 4a3.8 3.8 0 0 1-.4 1.7l-1.6-1.6V12a2 2 0 0 0-2-2h-.1L10.3 8.4A3.8 3.8 0 0 1 12 8Zm0-2a10.7 10.7 0 0 1 9 6a19.4 19.4 0 0 1-2.6 3.3l-1.5-1.5A4 4 0 0 0 12 8a3.8 3.8 0 0 0-1.8.4L8.7 6.9A10.6 10.6 0 0 1 12 6Z"
                />
              </svg>
            </div>
          </div>

          <div class="ay-field ay-field--captcha">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M12 2a6 6 0 0 0-6 6v2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V8a6 6 0 0 0-6-6Zm4 8H8V8a4 4 0 0 1 8 0Z"
                />
              </svg>
            </div>
            <input v-model="loginInfo.code" maxlength="6" placeholder="验证码" autocomplete="off" />
            <img class="ay-captcha" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </div>

          <div class="ay-login__options">
            <label class="ay-check">
              <input type="checkbox" v-model="rememberPwd" />
              <span>记住密码</span>
            </label>
          </div>
        </div>

        <div class="ay-login__submit">
          <button class="ay-login__btn" type="button" @click="login">登录</button>
        </div>
      </div>

      <div class="ay-login__quick">
        <div class="ay-quickBtn" @click="changInfoType(1)">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 12a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0 2c-4.42 0-8 2-8 4.5V21h16v-2.5C20 16 16.42 14 12 14Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">注册账号</div>
        </div>
        <div class="ay-quickBtn" @click="$parent.goNav('/')">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm8 10a8 8 0 0 1-1.3 4.3L16 14v-4l2-2.2A8 8 0 0 1 20 12ZM9 4.3A8 8 0 0 1 12 4a8.1 8.1 0 0 1 2.2.3L12 6.5ZM4 12a8 8 0 0 1 2-4.2L8 10v4l-2.7 2.3A8 8 0 0 1 4 12Zm8 8a8 8 0 0 1-3.9-1l2.9-2.5h2l2.9 2.5A8 8 0 0 1 12 20Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">先去逛逛</div>
        </div>
        <div class="ay-quickBtn" @click="$parent.openKefu()">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a8 8 0 0 0-8 8v5a3 3 0 0 0 3 3h1v-7H7v-1a5 5 0 0 1 10 0v1h-1v7h1a3 3 0 0 0 3-3v-5a8 8 0 0 0-8-8Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">联系客服</div>
        </div>
      </div>
    </div>

    <div class="ay-login__content" v-else>
      <div class="ay-login__brand ay-login__brand--stack">
        <div class="ay-login__brandText">
          <div class="ay-login__brandTitle"><span class="ay-login__ay">AY</span>聚盈国际</div>
          <div class="ay-login__brandSub">JYGJ GAME</div>
        </div>
      </div>

      <div class="ay-login__panel">
        <div class="ay-login__form">
          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 12a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0 2c-4.42 0-8 2-8 4.5V21h16v-2.5C20 16 16.42 14 12 14Z" />
              </svg>
            </div>
            <input v-model="registerInfo.name" maxlength="32" placeholder="用户名" autocomplete="off" />
          </div>

          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 0 1 4 0v2h-4Zm7 12H7v-8h10Z" />
              </svg>
            </div>
            <input v-model="registerInfo.password" maxlength="32" placeholder="登录密码" :type="psw2 ? 'password' : 'text'" autocomplete="off" />
            <div class="ay-field__action" @click="changPsw('psw2')">
              <svg v-if="psw2" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 6c5 0 9 6 9 6s-4 6-9 6s-9-6-9-6s4-6 9-6Zm0 10a4 4 0 1 0-4-4a4 4 0 0 0 4 4Z" /></svg>
              <svg v-else viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M2.3 3.7L3.7 2.3l18 18-1.4 1.4-2.1-2.1A10.8 10.8 0 0 1 12 18C7 18 3 12 3 12a21.3 21.3 0 0 1 4-4.5ZM12 8a4 4 0 0 1 4 4a3.8 3.8 0 0 1-.4 1.7l-1.6-1.6V12a2 2 0 0 0-2-2h-.1L10.3 8.4A3.8 3.8 0 0 1 12 8Zm0-2a10.7 10.7 0 0 1 9 6a19.4 19.4 0 0 1-2.6 3.3l-1.5-1.5A4 4 0 0 0 12 8a3.8 3.8 0 0 0-1.8.4L8.7 6.9A10.6 10.6 0 0 1 12 6Z" /></svg>
            </div>
          </div>

          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M17 9h-1V7a4 4 0 0 0-8 0v2H7a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2Zm-7-2a2 2 0 0 1 4 0v2h-4Zm7 12H7v-8h10Z" />
              </svg>
            </div>
            <input v-model="registerInfo.confirmPass" maxlength="32" placeholder="确认密码" :type="psw3 ? 'password' : 'text'" autocomplete="off" />
            <div class="ay-field__action" @click="changPsw('psw3')">
              <svg v-if="psw3" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 6c5 0 9 6 9 6s-4 6-9 6s-9-6-9-6s4-6 9-6Zm0 10a4 4 0 1 0-4-4a4 4 0 0 0 4 4Z" /></svg>
              <svg v-else viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M2.3 3.7L3.7 2.3l18 18-1.4 1.4-2.1-2.1A10.8 10.8 0 0 1 12 18C7 18 3 12 3 12a21.3 21.3 0 0 1 4-4.5ZM12 8a4 4 0 0 1 4 4a3.8 3.8 0 0 1-.4 1.7l-1.6-1.6V12a2 2 0 0 0-2-2h-.1L10.3 8.4A3.8 3.8 0 0 1 12 8Zm0-2a10.7 10.7 0 0 1 9 6a19.4 19.4 0 0 1-2.6 3.3l-1.5-1.5A4 4 0 0 0 12 8a3.8 3.8 0 0 0-1.8.4L8.7 6.9A10.6 10.6 0 0 1 12 6Z" /></svg>
            </div>
          </div>

          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M3 7h18v2H3Zm0 4h18v2H3Zm0 4h18v2H3Z" /></svg>
            </div>
            <input v-model="registerInfo.realname" maxlength="32" placeholder="真实姓名" autocomplete="off" />
          </div>

          <div class="ay-field">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a6 6 0 0 0-6 6v2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V8a6 6 0 0 0-6-6Zm4 8H8V8a4 4 0 0 1 8 0Z" /></svg>
            </div>
            <input v-model="registerInfo.paypassword" maxlength="32" placeholder="支付密码" type="password" autocomplete="off" />
          </div>

          <div class="ay-field ay-field--captcha">
            <div class="ay-field__icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 2a6 6 0 0 0-6 6v2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V8a6 6 0 0 0-6-6Zm4 8H8V8a4 4 0 0 1 8 0Z" />
              </svg>
            </div>
            <input v-model="registerInfo.code" maxlength="6" placeholder="验证码" autocomplete="off" />
            <img class="ay-captcha" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </div>
        </div>

        <div class="ay-login__submit">
          <button class="ay-login__btn" type="button" @click="register">注册</button>
        </div>
      </div>

      <div class="ay-login__quick">
        <div class="ay-quickBtn" @click="changInfoType(0)">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M15.4 19.4L8 12l7.4-7.4L14 3.2L5.2 12l8.8 8.8Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">返回登录</div>
        </div>
        <div class="ay-quickBtn" @click="$parent.goNav('/')">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm8 10a8 8 0 0 1-1.3 4.3L16 14v-4l2-2.2A8 8 0 0 1 20 12ZM9 4.3A8 8 0 0 1 12 4a8.1 8.1 0 0 1 2.2.3L12 6.5ZM4 12a8 8 0 0 1 2-4.2L8 10v4l-2.7 2.3A8 8 0 0 1 4 12Zm8 8a8 8 0 0 1-3.9-1l2.9-2.5h2l2.9 2.5A8 8 0 0 1 12 20Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">先去逛逛</div>
        </div>
        <div class="ay-quickBtn" @click="$parent.openKefu()">
          <div class="ay-quickBtn__icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a8 8 0 0 0-8 8v5a3 3 0 0 0 3 3h1v-7H7v-1a5 5 0 0 1 10 0v1h-1v7h1a3 3 0 0 0 3-3v-5a8 8 0 0 0-8-8Z" /></svg>
          </div>
          <div class="ay-quickBtn__text">联系客服</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      rememberPwd: false,
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();

    try {
      let saved = localStorage.getItem('ay_login_remember');
      if (saved) {
        saved = JSON.parse(saved);
        if (saved && saved.remember) {
          that.rememberPwd = true;
          that.loginInfo = {
            name: saved.name || '',
            password: saved.password || '',
            code: '',
          };
        }
      }
    } catch (e) {}
  },
  methods: {
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.$parent.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (!info.realname || info.realname.length < 2) {
        that.$parent.showTost(0, '请输入您的真实姓名!');
        return;
      }

      if (!info.paypassword || info.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        return;
      }
      let code = that.registerInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = null;
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info)
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          try {
            if (that.rememberPwd) {
              localStorage.setItem(
                'ay_login_remember',
                JSON.stringify({
                  remember: true,
                  name: info.name,
                  password: info.password,
                })
              );
            } else {
              localStorage.removeItem('ay_login_remember');
            }
          } catch (e) {}

          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.ay-login {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: #fff;
}

.ay-login__bg {
  position: absolute;
  inset: 0;
  background: url(/static/image/entry-bg-common.41cb103e1e52669ac5ff120bcfd671c1.jpg) center / cover no-repeat;
  transform: scale(1.03);
}

.ay-login__mask {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at top, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.7));
}

.ay-login__content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  padding: 70px 26px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.ay-login__content::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.ay-login__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 34px;
}

.ay-login__brand--stack {
  margin-bottom: 18px;
}

.ay-login__logo {
  width: 62px;
  height: 62px;
  display: block;
  object-fit: contain;
  margin-right: 10px;
}

.ay-login__brandText {
  line-height: 1.05;
}

.ay-login__brandTitle {
  font-weight: 800;
  font-size: 20px;
  letter-spacing: 1px;
}

.ay-login__brand--stack .ay-login__brandTitle {
  font-size: 28px;
  letter-spacing: 0.5px;
}

.ay-login__ay {
  font-size: 40px;
  font-weight: 900;
  margin-right: 6px;
  letter-spacing: 0;
}

.ay-login__brandSub {
  margin-top: 6px;
  font-size: 14px;
  opacity: 0.8;
  letter-spacing: 2px;
}

.ay-login__brand--stack .ay-login__brandSub {
  font-size: 16px;
}

.ay-login__title {
  width: 100%;
  max-width: 340px;
  margin-top: 20px;
  margin-bottom: 18px;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 1px;
}

.ay-login__form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ay-login__panel {
  width: 100%;
  max-width: 340px;
  padding: 18px 16px 16px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 14px 44px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.ay-field {
  height: 46px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.ay-field__icon {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.88);
  flex: 0 0 auto;
}

.ay-field__icon svg {
  width: 22px;
  height: 22px;
  display: block;
}

.ay-field input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 14px;
  padding: 0 10px;
  box-sizing: border-box;
}

.ay-field input::placeholder {
  color: rgba(255, 255, 255, 0.65);
}

.ay-field__action {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.78);
  flex: 0 0 auto;
}

.ay-field__action svg {
  width: 22px;
  height: 22px;
  display: block;
}

.ay-field--captcha input {
  padding-right: 8px;
}

.ay-captcha {
  height: 30px;
  width: 92px;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(0, 0, 0, 0.2);
}

.ay-login__options {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 2px 0;
}

.ay-check {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.ay-check input {
  width: 14px;
  height: 14px;
}

.ay-login__submit {
  width: 100%;
  margin-top: 16px;
}

.ay-login__btn {
  width: 100%;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: linear-gradient(180deg, #d7b78c 0%, #b98b5a 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 2px;
  box-shadow: 0 10px 22px rgba(202, 164, 123, 0.25);
}

.ay-login__quick {
  width: 100%;
  max-width: 340px;
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.ay-quickBtn {
  height: 58px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  user-select: none;
}

.ay-quickBtn__icon {
  width: 20px;
  height: 20px;
  color: rgba(255, 255, 255, 0.9);
}

.ay-quickBtn__icon svg {
  width: 20px;
  height: 20px;
  display: block;
}

.ay-quickBtn__text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.88);
}

.ay-login__topbar {
  width: 100%;
  max-width: 340px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.ay-login__back {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 12px;
  padding: 8px 0;
}

.ay-login__back svg {
  width: 20px;
  height: 20px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue